import { useLazyQuery } from '@apollo/client';
import { exportXlsModal } from 'motion-components';
import { gqlGetCollectorsRegionsQuery } from './graphql';
import { buildWhereFromFilterValues } from './filters';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { format, parseISO } from 'date-fns';

export const exportColumns = (t) => {
  return [
    // { fieldName: "id", fieldTitle: "Id", fieldType: "TEXT" },
    { fieldName: 'id', fieldTitle: 'ID', fieldType: 'TEXT' },
    { fieldName: 'collector.name', fieldTitle: t('Συλλέκτης'), fieldType: 'TEXT' },
    { fieldName: 'region.name', fieldTitle: t('Περιφέρεια'), fieldType: 'TEXT' },
    { fieldName: 'isActive', fieldTitle: t('Ενεργή Εγγραφή'), fieldType: 'TEXT' },
    { fieldName: 'firstRec', fieldTitle: t('Δήλωση'), fieldType: 'TEXT' },
    { fieldName: 'lastRec', fieldTitle: t('Αλλαγή'), fieldType: 'TEXT' },
  ];
};

export async function handleExport(client, queryState: any, t): Promise<void> {
  function useGetQuery() {
    const [get, { loading }] = useLazyQuery(gqlGetCollectorsRegionsQuery, {
      onCompleted: transformData,
    });
    const [result, setResult] = useState<any>([get, { loading, data: undefined }]);
    function transformData(data) {
      const recs = data.getCollectorsRegions.data.map((values) => {
        return {
          ...values,
          isActive: !values.isActive ? t('ΟΧΙ') : t('ΝΑΙ'),
          firstRec: ` ${
            values.firstDate ? format(parseISO(values.firstDate), 'dd/MM/yy HH:mm') : ''
          }  - ${values.firstUser}`,
          lastRec: ` ${
            values.lastDate ? format(parseISO(values.lastDate), 'dd/MM/yy HH:mm') : ''
          }  - ${values.lastUser}`,
        };
      });
      const trsData = {
        getCollectorsRegions: { data: recs, recordCount: data?.getCollectorsRegions?.recordCount },
      };
      setResult([get, { loading, data: trsData }]);
    }
    return result;
  }
  const filterVariables = {
    where: buildWhereFromFilterValues(queryState?.filterValues),
  };
  await exportXlsModal({
    apolloClient: client,
    exportFileName: 'export CollectorRegions',
    getLazyQuery: useGetQuery,
    columnsDef: exportColumns(t),
    filterVariables: filterVariables,
  });
}
